/**
 * Browser-side equivalent of the server's `customQuestionHash`. Same
 * normalisation: trim + lowercase the question, sort + lowercase + trim
 * the options, sha256 of `${q}|${opts.join('|')}`. The web version uses
 * the SubtleCrypto API.
 *
 * MUST stay in lockstep with `apps/api/src/exchanges/manual/customQuestion.ts`
 * — the server uses the hash for cross-session reuse lookup, so any
 * divergence breaks reuse silently.
 */
export async function customQuestionHash(question: string, options: string[]): Promise<string> {
  const normalized = question.trim().toLowerCase();
  const sortedOpts = [...options].map((o) => o.trim().toLowerCase()).sort();
  const input = `${normalized}|${sortedOpts.join('|')}`;
  const data = new TextEncoder().encode(input);
  const buf = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
